import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center">
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="input-field h-8 px-3 py-1 text-xs sm:h-9 sm:text-sm"
        aria-label="Language"
      >
        <option value="en">EN</option>
        <option value="hi">HI</option>
      </select>
    </div>
  );
}
